import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiFormGroup = () =>
  ({
    MuiFormGroup: {
      defaultProps: {},
      styleOverrides: {
        root: {
          padding: spacing(1, 0),
          gap: spacing(2),
          /**
           * MUI does NOT apply component overrides set to `MuiRadioGroup` on top level -.-'
           */
          '&.MuiRadioGroup-root': {
            '> .MuiFormControlLabel-root': {
              padding: spacing(0),
            },
          },
          '> .MuiFormControlLabel-root': {
            marginTop: spacing(0),
            height: spacing(3),
          },
        },
      },
    },
  }) satisfies ComponentCreation
